import { Fragment } from "react";
import ModalNew from "./Modal";
import PopupHeader from "./common/popupHeader";
import SmartButton from "../buttons/SmartButton";

function ConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "primary",
  cancelButtonClass = "secondary",
  isLoading = false,
  error = "",
}) {
  if (!isOpen) return null;

  return (
    <ModalNew className="confirmation-modal">
      <PopupHeader 
        title={title}
        setOpenState={onClose}
        hideCloseButton={true}
      />
      <div className="confirmation-modal-form">
        <div className="confirmation-content">
          {message.split('\n\n').map((paragraph, index) => (
            <p key={index} style={{ marginBottom: index < message.split('\n\n').length - 1 ? "12px" : "0" }}>
              {paragraph}
            </p>
          ))}
          {error && (
            <p className="text-danger" style={{ marginTop: "12px", marginBottom: 0 }}>
              {error}
            </p>
          )}
        </div>
        <div className="modal-actions">
          <SmartButton
            type="button"
            className={`cta-button ${cancelButtonClass}`}
            onClick={onClose}
            disabled={isLoading}
            text={cancelText}
          />
          <SmartButton
            type="button"
            className={`cta-button ${confirmButtonClass}`}
            onClick={onConfirm}
            isSubmitting={isLoading}
            text={confirmText}
          />
        </div>
      </div>
    </ModalNew>
  );
}

export default ConfirmationModal;
